import { attachmentDisplayType, attachmentRendererType } from "@/src/constants/attachmentConstants.js";
import ImageAttachmentDisplay from "@/src/components/attachment_components/ImageAttachmentDisplay.vue";
import VideoAttachmentDisplay from "@/src/components/attachment_components/VideoAttachmentDisplay.vue";
import AudioAttachmentDisplay from "@/src/components/attachment_components/AudioAttachmentDisplay.vue";
import FileAttachmentDisplay from "@/src/components/attachment_components/FileAttachmentDisplay.vue";

export const attachmentComponentMapping = {
  [attachmentDisplayType.IMAGE]: {
    [attachmentRendererType.UPLOAD]: FileAttachmentDisplay,
    [attachmentRendererType.PREVIEW]: ImageAttachmentDisplay,
  },
  [attachmentDisplayType.VIDEO]: {
    [attachmentRendererType.UPLOAD]: FileAttachmentDisplay,
    [attachmentRendererType.PREVIEW]: VideoAttachmentDisplay,
  },
  [attachmentDisplayType.AUDIO]: {
    [attachmentRendererType.UPLOAD]: FileAttachmentDisplay,
    [attachmentRendererType.PREVIEW]: AudioAttachmentDisplay,
  },
  [attachmentDisplayType.FILE]: {
    [attachmentRendererType.UPLOAD]: FileAttachmentDisplay,
    [attachmentRendererType.PREVIEW]: FileAttachmentDisplay,
  },
};

